import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchUsers = async (user, page, limit, sumsubFilter, startDate, endDate, search, filterType) => {

  const params = `?page=${page}&limit=${limit}&sumsubFilter=${sumsubFilter}&startDate=${startDate}&endDate=${endDate}`
  const searchParam = `${search !== '' ? `&value=${search}` : ''}${filterType !== 'all' ? `&filter=${filterType}` : ''}`

  try {
    const {data} = await axios.get(`${API_BASE_URL}/agbk/clients${params}${searchParam}`,
      buildHeaders(user));
    return data?.data;
  } catch (error) {
    console.error(error);
  }
}

export const fetchUserById = async (user, id) => {

  try {
    const {data} = await axios.get(`${API_BASE_URL}/agbk/clients/${id}`,
      buildHeaders(user));
    return data?.data;
  } catch (error) {
    console.error(error);
  }
}